import { Button } from "components/shadcn/ui/button";
import React from "react";

const Home: React.FC = () => {
  const loginUrl = `${process.env.REACT_APP_CLERK_PRIMARY_APP_URL}/sign-in#/?redirect_url=${process.env.REACT_APP_DOCS_APP_URL}?app=docs`;
  const handleLogin = () => {
    window.location.href = loginUrl;
  };

  return (
    <div
      className="flex justify-center flex-col gap-4 items-center"
      style={{ textAlign: "center", marginTop: "20%" }}
    >
      <h1 className="font-bold text-primary-700">
        Welcome to BizCrunch Docs App
      </h1>
      <p>
        Please click on the Sign in button to continue using the docs app.
      </p>
      <Button variant={"primary"} onClick={() => handleLogin()}>
        Sign in
      </Button>
    </div>
  );
};

export default Home;
